"use strict";
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StockMovementsApi = exports.StockMovementsApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
// @ts-ignore
const models_1 = require("../models");
/**
 * StockMovementsApi - axios parameter creator
 * @export
 */
const StockMovementsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {InlineObject9} inlineObject9
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStockMovementsListPost: async (inlineObject9, options = {}) => {
            // verify required parameter 'inlineObject9' is not null or undefined
            (0, common_1.assertParamExists)('getStockMovementsListPost', 'inlineObject9', inlineObject9);
            const localVarPath = `/api/stock-movements/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(inlineObject9, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.StockMovementsApiAxiosParamCreator = StockMovementsApiAxiosParamCreator;
/**
 * StockMovementsApi -
 */
var StockMovementsApi;
(function (StockMovementsApi) {
    /**
     *
     * @param {InlineObject9} inlineObject9
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof StockMovementsApi
     * url /api/stock-movements/list
     */
    async function getStockMovementsListPost(inlineObject9, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.StockMovementsApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.getStockMovementsListPost(inlineObject9, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_1.parseBatchResponseIStockMovementEntity)(res.data);
            return res;
        });
    }
    StockMovementsApi.getStockMovementsListPost = getStockMovementsListPost;
})(StockMovementsApi || (exports.StockMovementsApi = StockMovementsApi = {}));
